<template>
  <div>
  <div class="container-fluid">
            <div class="success_message" v-text="this.$root.success_message" v-if="this.$root.success_message != ''"></div>
            <div class="error_message" v-text="this.$root.error_message" v-if="this.$root.error_message != ''"></div>
            <div class="row">
                <div class="col-12" v-html="content">
                    <!--div class="content-pages">
                        <h2 class="page-title">Return Policy</h2>
                        <ul>
                        <li>We have <b>30 Days No Questions Asked</b> Return Policy</li>
                        <li>Purchased products can be returned within 30 days from the date of purchase (order date)</li>
                        <li v-if="this.$root.store==1">Due to the hygiene concern, returns are not available for Masks.</li>
                        <li>Return the product in its original condition, keeping the tags and packaging intact</li>
                        <li>If a customer wants to cancel the order, he/she can do the same by calling/whatsapp us at  +91-8800698168, <b>Email Us -</b> <a href="mailto:customercare@tcnsclothing.com" target="blank">customercare@tcnsclothing.com</a> (From 10 AM to 6 PM, Mon to Sat). We are closed on Sunday & Bank holidays.</li>
                        <li>If the product is already shipped from our end, we cannot accept cancellation for it</li>
                        <li>Any promotional voucher (Gift Voucher, Discount or any other offer voucher) used for the cancelled orders will not be refunded.</li>
                        <li>If a customer is sending back the product through courier, only Rs 100 will be refunded for the same</li>
                        <li>TCNS Clothing Co. Ltd. Reserves the right to alter any / all the Terms and Conditions</li>
                        <li>Terms are void where prohibited by law. Terms and Conditions of the Voucher are governed by laws of India</li>
                        <li>Any dispute between the TCNS and the Service Provider shall be resolve by mutual discussions between the authorized signatories. If the dispute remains unresolved, the parties may refer such dispute to a court of law located within the jurisdiction of courts in Delhi only </li>
                        </ul>
                    </div-->
                </div>
            </div>
            
        </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'cancel_policy',
  metaInfo () {
      return {
          title:this.meta_title,
          meta: [
          {
              name: 'description',
              content: this.meta_description
          },
          {
              property: 'keywords',
              content: this.meta_keyword
          }
          ]
      }
  },
  data() {
        return {
            meta_title:'',
            meta_description:'',
            meta_keyword:'',
            content:''
        };
    },
    beforeMount() {
            this.$root.page_loader = true;
            axios.get(this.$root.api_url+`/pim/pimresponse.php?service=cms_page&url_key=return-policy&store=${this.$root.store}`)
            .then(response => {
                this.$root.page_loader = false;
                if(response.data.response.success==1){
                    this.$root.breadcrumb = response.data.result[0].name;
                    this.$root.page_loader = false;
                    this.content=response.data.result[0].content;
                    this.meta_title = response.data.result[0].meta_title;
                    this.meta_description = response.data.result[0].meta_description;
                    this.meta_keyword = '';
                }
                else
                {
                    this.$router.push('/404');
                }
            }).catch(error=>{
                this.$root.page_loader = false;
            })
        },
    created () {
        window.scrollTo(0, 0);
        // this.$root.breadcrumb = 'Support';
        // if(this.$root.store === 1){
        //     this.meta_title = 'Return Policy';
        //     this.meta_description = 'Return Policy';
        //     this.meta_keyword = 'Return Policy';
        // }
        // else
        // {
        //    this. meta_title = 'Return Policy';
        //    this.meta_description = 'Return Policy';
        //    this.meta_keyword = 'Return Policy';
        // }
    }
}
</script>
